import {
  Button,
  Container,
  Stack,
  Typography,
  IconButton,
  Box,
  Grid,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Divider,
  Collapse,
  CircularProgress,
  Pagination,
  PaginationItem,
  Snackbar,
  Alert,
  InputAdornment
} from '@mui/material';
import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import { Link as RouterLink } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Iconify from 'src/components/Iconify';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import { api } from 'src/Api';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import GooglePlacesFilter from 'src/components/GooglePlacesFilter';
import {
  GoogleMap,
  useJsApiLoader,
  DirectionsRenderer,
  Polyline,
  Marker,
  OverlayView,
  useLoadScript
} from '@react-google-maps/api';
import GooglePlaces from 'src/components/GooglePlaces';
import LocationPickerMap from 'src/components/LocationPickerMap';

function SaveShipmentList() {
  const theme = useTheme();
  const userData = JSON.parse(localStorage.getItem('user'));

  const [origin, setOrigin] = useState('');
  const [dhO, setDhO] = useState('');
  const [destination, setDestination] = useState('');
  const [dhD, setDhD] = useState('');
  const [equipmentType, setEquipmentType] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const [loadingSave, setloadingSave] = useState(false);
  const [loading, setloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [equipmentList, setEquipmentList] = useState([]);
  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [openBidModal, setOpenBidModal] = useState(false);
  const [rateFlat, setRate] = useState('');

  const [selectLoad, setSelectLoad] = useState('');
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [loadingSaveBooking, setloadingSaveBooking] = useState(false);

  const [clearFilterTrigger, setClearFilterTrigger] = useState(false);

  const [searchLoadList, setSearchLoadList] = useState([]);

  const [expandedRow, setExpandedRow] = useState(null); // To track expanded row

  const [mapOpen, setMapOpen] = useState(false);
  const [locationType, setLocationType] = useState(''); // 'origin' or 'destination'

  useEffect(() => {
    getEquipments();
    getSearchLoadData(1);
  }, []);

  useEffect(() => {
    getSearchLoadData(1);
  }, [origin, destination]);

  useEffect(() => {
    if (clearFilterTrigger) {
      getSearchLoadData(1);
      setClearFilterTrigger(false); // Reset kar dete hain taake ye baar baar trigger na ho
    }
  }, [clearFilterTrigger]);

  function getEquipments() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_equipments, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEquipmentList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function getSearchLoadData(page) {
    setSearchLoadList([]);
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    origin?.address && queryParams.append('location_origin', origin?.address); // Required
    origin?.country && queryParams.append('country_origin', origin?.country); // Optional
    origin?.city && queryParams.append('city_origin', origin?.city); // Optional
    origin?.state && queryParams.append('state_origin', origin?.state); // Optional
    origin?.lat && queryParams.append('lat_origin', origin?.lat); // Required
    origin?.lon && queryParams.append('lon_origin', origin?.lon); // Required
    origin?.zone && queryParams.append('zone_origin', origin?.zone); // Required
    dhO && queryParams.append('dho', dhO);
    destination?.address && queryParams.append('location_destination', destination?.address); // Required
    destination?.country && queryParams.append('country_destination', destination?.country); // Optional
    destination?.city && queryParams.append('city_destination', destination?.city); // Optional
    destination?.state && queryParams.append('state_destination', destination?.state); // Optional
    destination?.lat && queryParams.append('lat_destination', destination?.lat); // Required
    destination?.lon && queryParams.append('lon_destination', destination?.lon); // Required
    destination?.zone && queryParams.append('zone_destination', destination?.zone); // Required
    dhD && queryParams.append('dhd', dhD);
    equipmentType && queryParams.append('equipment_id', equipmentType);
    startDate && queryParams.append('pickup_earliest', moment(startDate).format('YYYY-MM-DD'));
    endDate && queryParams.append('pickup_lattest', moment(endDate).format('YYYY-MM-DD'));

    fetch(`${api.get_saved_shipment}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSearchLoadList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setloading(false);
          setpagesCount(0);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  //add shipment function
  function HandlePlaceBid() {
    setIsSaveLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    selectLoad && formdatas.append('booking_id', selectLoad?.id); // Required
    rateFlat && formdatas.append('amount', rateFlat); // Required

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.bid_placed, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          getSearchLoadData(1);
          setExpandedRow(null);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setIsSaveLoading(false);
          handleCloseBidModal();
          // setTimeout(() => {
          //     navigate(-1)
          // }, 2000);
        } else {
          setIsSaveLoading(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setIsSaveLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  function handleSaveBookingShipment() {
    setloadingSaveBooking(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);
    const formData = new FormData();
    selectLoad?.id && formData.append('booking_id', selectLoad?.id);
    selectLoad?.rate && formData.append('amount', selectLoad?.rate);
    formData.append('type', 'booking');

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    fetch(api.save_booking, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setExpandedRow(null);
          getSearchLoadData(1);
          setloadingSaveBooking(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        } else {
          setloadingSaveBooking(false);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setloadingSaveBooking(false);
        console.log('error', error);
      });
  }

  function handleSaveShipment() {
    setloadingSave(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    selectLoad && queryParams.append('id', selectLoad?.id);

    fetch(`${api.mark_as_save_shipment}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          getSearchLoadData(1);

          setExpandedRow(null);
          setloadingSave(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
        } else {
          setloadingSave(false);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setloadingSave(false);
        console.log('error', error);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleStartDateChange = (value) => {
    setStartDate(value ? value.toISOString() : null);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value ? value.toISOString() : null);
  };

  // Detail Dialog Handlers
  const handleOpenDetailsModal = (row) => {
    setOpenDetailsModal(true);
    setSelectLoad(row);
  };

  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
    setSelectLoad('');
  };

  // place bid Dialog Handlers
  const handleOpenBidModal = () => setOpenBidModal(true);
  const handleCloseBidModal = () => {
    setOpenBidModal(false);
    setRate('');
  };

  const handlePageChange = (event, value) => {
    searchLoadList.length = 0;
    setPage(value);
    getSearchLoadData(value);
  };

  const handleClearFilter = () => {
    setPage(1);
    setOrigin(''); // Reset origin here
    setDhO('');
    setDhD('');
    setDestination('');
    setEquipmentType('');
    setStartDate(null);
    setEndDate(null);
  };

  const handleRowClick = (rowIndex) => {
    setExpandedRow((prevIndex) => (prevIndex === rowIndex ? null : rowIndex));
  };

  const handleLocationIconClick = (type) => {
    setLocationType(type);
    setMapOpen(true);
  };

  const handleSelectLocation = (type, locationData) => {
    if (type === 'origin') {
      setOrigin(locationData);
    } else if (type === 'destination') {
      setDestination(locationData);
    }
    setMapOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Page title={`Saved Shipments | ${process.env.REACT_APP_PROJECTNAME}`}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h4" sx={{ color: '#010f58' }}>
              Saved Shipments
            </Typography>
          </Stack>

          <Box sx={{ flexGrow: 1, marginTop: 2 }}>
            <Grid
              container
              spacing={1}
              alignItems="flex-start"
              justifyContent="space-between"
              mb={2}
            >
              {/* Origin Field */}
              <Grid item xs={12} sm={4.5} md={4.3}>
                <GooglePlaces
                  width={'100%'}
                  onResult={(val) => {
                    setOrigin(val);
                  }}
                  placeholder={'Origin'}
                  // regions={true}
                  address={origin?.address} // Ensure origin updates here
                  stylePinIcon={{ fontSize: 12 }}
                  styleCountryText={{ fontSize: 10 }}
                  styleCityText={{ fontSize: 9 }}
                  boxCountryCity={{ width: 20, paddingTop: 0 }}
                />

                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 5
                  }}
                  onClick={() => handleLocationIconClick('origin')}
                >
                  <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                  <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
                </div>
              </Grid>

              {/* DH-O Field */}
              <Grid item xs={12} sm={1.3} md={1.3}>
                <TextField
                  label="DH-O"
                  type="number"
                  value={dhO}
                  onChange={(e) => {
                    if (e.target.value.length <= 4) {
                      setDhO(e.target.value);
                    }
                  }}
                  fullWidth
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>

              <Grid item mt={1.7}>
                <Iconify icon={'fa6-solid:right-left'} sx={{ fontSize: 12 }} />
              </Grid>

              {/* Destination Field */}
              <Grid item xs={12} sm={4.5} md={4.3}>
                <GooglePlaces
                  width={'100%'}
                  onResult={(val) => setDestination(val)}
                  placeholder={'Destination'}
                  // regions={true}
                  address={destination?.address}
                  stylePinIcon={{ fontSize: 12 }}
                  styleCountryText={{ fontSize: 10 }}
                  styleCityText={{ fontSize: 9 }}
                  boxCountryCity={{ width: 20, paddingTop: 0 }}
                />
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 5
                  }}
                  onClick={() => handleLocationIconClick('destination')}
                >
                  <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                  <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
                </div>
              </Grid>

              {/* DH-D Field */}
              <Grid item xs={12} sm={1.3} md={1.3}>
                <TextField
                  label="DH-D"
                  type="number"
                  value={dhD}
                  onChange={(e) => {
                    if (e.target.value.length <= 4) {
                      setDhD(e.target.value);
                    }
                  }}
                  fullWidth
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} alignItems="center" justifyContent="space-between" mb={2}>
              {/* Equipment Type Field */}
              <Grid item xs={12} sm={5.8} md={4.5}>
                <TextField
                  select
                  label="Equipment Type"
                  value={equipmentType}
                  onChange={(e) => setEquipmentType(e.target.value)}
                  fullWidth
                  // error={Boolean(errors.equipmentType)}
                  // helperText={errors.equipmentType}
                  InputLabelProps={{
                    shrink: true, // Force the label to shrink when a value is selected
                    style: {
                      fontSize: '11px',
                      lineHeight: '1.2',
                      transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                    }
                  }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: {
                          paddingTop: 0 // Ensure the dropdown aligns properly
                        }
                      }
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14,
                      height: '50px', // Set the height of the input field
                      padding: '0px 0px' // Add padding to input field
                    }
                  }}
                >
                  {equipmentList.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            textAlign: 'start',
                            display: 'flex',
                            fontWeight: 'normal',
                            marginRight: 10,
                            fontSize: 14
                          }}
                        >
                          {option.name}
                        </span>
                        <span
                          style={{
                            flex: 1,
                            width: '100%',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: '#000'
                          }}
                        >
                          {option.code}
                        </span>
                      </div>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Date Range Field */}
              <Grid item xs={12} sm={4.5} md={5.3} sx={{ marginTop: -1 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    components={['DatePicker']}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      flexDirection: 'row'
                    }}
                  >
                    <Grid item>
                      <DatePicker
                        className="custom-textfield"
                        label="Start Date"
                        value={startDate ? dayjs(startDate) : null}
                        onChange={(newValue) => handleStartDateChange(newValue)}
                        // minDate={dayjs()}
                      />
                    </Grid>
                    <Grid item>
                      <DatePicker
                        className="custom-textfield"
                        label="End Date"
                        value={endDate ? dayjs(endDate) : null}
                        onChange={(newValue) => handleEndDateChange(newValue)}
                      />
                    </Grid>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>

              {/* Search Button */}
              <Grid item xs={12} sm={4.5} md={1}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 40, width: '100%' }}
                  onClick={() => getSearchLoadData(1)}
                >
                  <SearchIcon />
                </Button>
              </Grid>
              <Grid item xs={12} sm={4.5} md={1}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ height: 40, width: '100%' }}
                  onClick={handleClearFilter}
                >
                  <CloseIcon />
                </Button>
              </Grid>
            </Grid>
          </Box>

          <TableContainer
            component={Paper}
            sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AGE</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>BID</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>PICK UP</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>EQUIPMENT</TableCell>
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchLoadList.map((row, index) => {
                  return (
                    <>
                      <TableRow
                        key={index}
                        onClick={() => {
                          handleRowClick(index);
                          setSelectLoad(row);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        <TableCell sx={{ fontSize: '12px' }}>{row.age}</TableCell>
                        <TableCell sx={{ fontSize: '12px' }}>
                          {row.rate ? (
                            <NumericFormat
                              value={row.rate ? parseFloat(row.rate).toFixed(2) : '0.00'}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'$'}
                            />
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', width: 50 }}>
                          {row?.mark_as_bid ? (
                            <Iconify icon="streamline:check-solid" sx={{ color: '#010f58' }} />
                          ) : (
                            '-'
                          )}
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px' }}>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'flex-start'
                            }}
                          >
                            <p
                              style={{
                                fontWeight: 'bold',
                                color: '#010f58',
                                marginRight: 5,
                                fontSize: 10
                              }}
                            >
                              {row?.total_mil || '-'}
                            </p>
                            <div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginBottom: -5
                                }}
                              >
                                <div
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 100,
                                    backgroundColor: 'white',
                                    border: '2px solid #010f58',
                                    marginRight: 5
                                  }}
                                ></div>
                                <p
                                  style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '150px' // Adjust this width as needed
                                  }}
                                >
                                  {row?.location_origin}
                                </p>
                              </div>
                              <div>
                                <Iconify
                                  icon="mingcute:arrow-down-line"
                                  style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                                />
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                  marginTop: -10
                                }}
                              >
                                <div
                                  style={{
                                    height: 6,
                                    width: 6,
                                    borderRadius: 100,
                                    backgroundColor: '#010f58',
                                    border: '2px solid #010f58',
                                    marginRight: 5
                                  }}
                                ></div>
                                <p
                                  style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    maxWidth: '150px' // Adjust this width as needed
                                  }}
                                >
                                  {row?.location_destination}
                                </p>
                              </div>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px' }}>
                          <Typography style={{ fontSize: 12, width: 75 }}>
                            {moment(row.pickup_earliest).format('MM/DD/YYYY')} -{' '}
                            {moment(row.pickup_lattest).format('MM/DD/YYYY')}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px', width: 200 }}>
                          <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <p>{row?.equipment_type || '-'} </p>
                              <p>{row?.equipment_name || '-'} </p>
                            </div>
                            <div
                              style={{
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-end',
                                justifyContent: 'center'
                              }}
                            >
                              <p>
                                {row.length_ft} {row?.length_unit}
                              </p>
                              <p>
                                {row.weight_lbs} {row?.weight_unit}
                              </p>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell sx={{ fontSize: '12px' }}>
                          <Typography
                            // className="routerLink"
                            sx={{
                              color: '#010f58',
                              cursor: 'pointer',
                              fontWeight: 'bold',
                              textDecoration: 'underline',
                              fontSize: '12px'
                            }}
                            onClick={() => {
                              handleOpenDetailsModal(row);
                              // setSelectLoad(row);
                            }}
                          >
                            {row.company.company
                              ? row.company.company
                              : row.company.first_name + ' ' + row.company.last_name}
                          </Typography>
                        </TableCell>
                      </TableRow>

                      <TableRow style={{ display: expandedRow !== index && 'none' }}>
                        <TableCell
                          style={{ backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 }}
                          colSpan={8}
                        >
                          <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                            <Grid container spacing={2} mb={2} style={{ height: '30%' }}>
                              {/* Trip Section */}
                              <Grid item xs={12} sm={6} style={{ position: 'relative' }}>
                                {/* Header */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    TRIP
                                  </p>
                                </Box>

                                {/* Content Section */}
                                <Box
                                  style={{
                                    marginTop: 2,
                                    paddingLeft: 10,
                                    paddingRight: 10,
                                    position: 'relative'
                                  }}
                                >
                                  {/* Row 1 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:dot-square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.location_origin}
                                    </Typography>
                                  </Box>

                                  {/* Row 2 */}
                                  <Box
                                    style={{
                                      display: 'flex',
                                      alignItems: 'flex-start', // Align text and icons properly
                                      height: 60
                                    }}
                                  >
                                    <Box
                                      style={{
                                        width: 13, // Fixed icon width
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginRight: 6
                                      }}
                                    >
                                      <Iconify
                                        icon="f7:square-fill"
                                        style={{
                                          fontSize: 13, // Fixed icon size
                                          color: '#010f58'
                                        }}
                                      />
                                    </Box>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        lineHeight: '1.5', // Ensure consistent line spacing
                                        overflow: 'hidden', // Handle overflow
                                        textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                        display: '-webkit-box', // Enable line clamping
                                        WebkitLineClamp: 3, // Limit to 3 lines
                                        WebkitBoxOrient: 'vertical', // Required for line clamping,
                                        color: '#010f58'
                                      }}
                                    >
                                      {selectLoad?.location_destination}
                                    </Typography>
                                  </Box>
                                </Box>

                                {/* Vertical Icons */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    position: 'absolute',
                                    top: 70,
                                    left: 26.5
                                  }}
                                >
                                  {Array(4)
                                    .fill(null)
                                    .map((_, idx) => (
                                      <Iconify
                                        key={idx}
                                        icon="pepicons-pop:line-y"
                                        style={{
                                          fontSize: 7, // Fixed line size
                                          color: '#010f58',
                                          marginBottom: 3
                                        }}
                                      />
                                    ))}
                                  <Iconify
                                    icon="ion:arrow-down-outline"
                                    style={{
                                      fontSize: 11, // Fixed arrow size
                                      color: '#010f58'
                                    }}
                                  />
                                </Box>
                              </Grid>

                              {/* Details Section */}
                              <Grid item xs={12} sm={6}>
                                <Box
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: '#010f58',
                                    padding: '4px 10px',
                                    marginTop: 10,
                                    marginBottom: 10
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 10,
                                      letterSpacing: 0.8,
                                      color: 'white',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    DETAILS
                                  </p>
                                </Box>

                                <Box
                                  style={{
                                    paddingLeft: 10,
                                    paddingRight: 10
                                  }}
                                >
                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Commodity :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.commodity || '-'}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      Reference ID :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.reference_id || '-'}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography style={{ color: 'grey', fontSize: 12 }}>
                                      DHO | DHD :
                                    </Typography>
                                    <Typography
                                      style={{ flex: 1, fontSize: 12, textAlign: 'right' }}
                                    >
                                      {selectLoad?.dhO && selectLoad?.dhd
                                        ? `${selectLoad?.dhO} | ${selectLoad?.dhd}`
                                        : '-'}
                                    </Typography>
                                  </Box>

                                  <Box
                                    sx={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'flex-start',
                                      marginBottom: 0.5
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        width: '17%',
                                        color: 'grey',
                                        fontSize: 12
                                      }}
                                    >
                                      Comment :
                                    </Typography>
                                    <Typography
                                      style={{
                                        fontSize: 11,
                                        marginLeft: 20,
                                        flex: 1
                                      }}
                                    >
                                      {selectLoad?.comments || '-'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Grid>
                            </Grid>

                            <Divider />

                            {/* MARKET RATE */}
                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: 20,
                                marginBottom: 10,
                                backgroundColor: '#010f58',
                                padding: '4px 0px 4px 10px'
                              }}
                            >
                              <p
                                style={{
                                  fontSize: 10,
                                  letterSpacing: 0.8,
                                  fontWeight: 'bold',
                                  color: 'white'
                                }}
                              >
                                MARKET RATE
                              </p>
                            </Box>

                            <Box
                              style={{
                                border: '2px solid #010f58',
                                marginBottom: 10,
                                paddingBottom: 10
                              }}
                            >
                              <Box
                                style={{
                                  backgroundColor: '#010f58',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '2px 10px 2px 10px'
                                }}
                              >
                                <Typography
                                  style={{
                                    fontSize: 10,
                                    letterSpacing: 0.8,
                                    fontWeight: 'bold',
                                    color: 'white'
                                  }}
                                >
                                  SPOT RATE
                                </Typography>
                                <Typography
                                  style={{
                                    fontSize: 10,
                                    color: '#ffffff'
                                  }}
                                >
                                  {selectLoad?.city_origin !== 'undefined' &&
                                  selectLoad?.city_destination !== 'undefined'
                                    ? `${selectLoad?.city_origin} - ${selectLoad?.city_destination}`
                                    : `${selectLoad?.country_origin} - ${selectLoad?.country_destination}`}
                                </Typography>
                              </Box>

                              <Typography
                                sx={{
                                  fontSize: 10,
                                  textAlign: 'end',
                                  marginTop: 1,
                                  marginRight: 1,
                                  color: '#000000'
                                }}
                              >
                                {selectLoad?.total_mil || 0} km | 30d average
                              </Typography>

                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '5px 10px 0px 10px'
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}
                                >
                                  Average rate :
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    textAlign: 'right',
                                    flex: 1,
                                    color: '#000000'
                                  }}
                                >
                                  {selectLoad?.market_rate?.spot_rate?.average_rate
                                    ? `$${selectLoad?.market_rate?.spot_rate?.average_rate}/Km`
                                    : '0 /km'}
                                </Typography>
                              </Box>

                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 10px 0px 10px'
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}
                                >
                                  Average rate range :
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    color: '#000000',
                                    textAlign: 'right',
                                    flex: 1
                                  }}
                                >
                                  {selectLoad?.market_rate?.spot_rate?.min_rate ||
                                  selectLoad?.market_rate?.spot_rate?.max_rate
                                    ? `$${selectLoad?.market_rate?.spot_rate?.min_rate?.toFixed(
                                        2
                                      )}/Km - $${selectLoad?.market_rate?.spot_rate?.max_rate?.toFixed(
                                        2
                                      )}/Km`
                                    : '0 - 0'}
                                </Typography>
                              </Box>

                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 10px 0px 10px'
                                }}
                              >
                                <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                  Average amount range :
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    color: '#000000',
                                    textAlign: 'right',
                                    flex: 1
                                  }}
                                >
                                  {selectLoad?.market_rate?.spot_rate?.min_rate ||
                                  selectLoad?.market_rate?.spot_rate?.max_rate
                                    ? `$${selectLoad?.market_rate?.spot_rate?.min_rate?.toFixed(
                                        2
                                      )}/Km - $${selectLoad?.market_rate?.spot_rate?.max_rate?.toFixed(
                                        2
                                      )}/Km`
                                    : '0 - 0'}
                                </Typography>
                              </Box>

                              <Box
                                style={{
                                  backgroundColor: '#010f58',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '2px 10px 2px 10px',
                                  marginTop: 25
                                }}
                              >
                                <Typography
                                  style={{
                                    fontSize: 10,
                                    letterSpacing: 0.8,
                                    fontWeight: 'bold',
                                    color: 'white'
                                  }}
                                >
                                  FOR SHIPMENT RATE
                                </Typography>
                              </Box>

                              <Typography
                                sx={{
                                  fontSize: 10,
                                  textAlign: 'end',
                                  marginTop: 1,
                                  marginRight: 1,
                                  color: '#000000',
                                  marginBottom: 1
                                }}
                              >
                                {selectLoad?.total_mil || '0'} km
                              </Typography>

                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 10px 0px 10px'
                                }}
                              >
                                <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                  Rate :
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 12,
                                    oolor: '#000000'
                                  }}
                                >
                                  <NumericFormat
                                    value={
                                      selectLoad?.rate_per_mil
                                        ? parseFloat(selectLoad?.rate_per_mil).toFixed(2)
                                        : '0'
                                    }
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                    // style={{ marginRight: 5 }}
                                  />
                                </Typography>
                              </Box>

                              <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  padding: '0px 10px 0px 10px'
                                }}
                              >
                                <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                  Total Amount :
                                </Typography>
                                <Typography
                                  sx={{
                                    fontSize: 14,
                                    color: '#000000',
                                    textAlign: 'right',
                                    flex: 1,
                                    fontWeight: 'bold'
                                  }}
                                >
                                  ${selectLoad?.rate || '0'}
                                </Typography>
                              </Box>
                            </Box>

                            {userData?.role?.id !== 6 && (
                              <>
                                {selectLoad?.my_shipment == false && (
                                  <>
                                    <Divider style={{ margin: '20px 0' }} />
                                    <Box>
                                      <Grid
                                        item
                                        sx={{
                                          display: 'flex',
                                          justifyContent: 'flex-end',
                                          alignItems: 'center'
                                        }}
                                      >
                                        {selectLoad?.allow_bid == 1 && (
                                          <Button
                                            disabled={selectLoad?.mark_as_bid}
                                            variant="outlined"
                                            onClick={handleOpenBidModal}
                                            style={{
                                              borderRadius: 100,
                                              fontSize: 11,
                                              marginRight: 10
                                            }}
                                          >
                                            PLACE BID
                                          </Button>
                                        )}

                                        <LoadingButton
                                          variant="contained"
                                          loading={loadingSaveBooking}
                                          disabled={loadingSaveBooking || selectLoad?.mark_as_bid}
                                          onClick={handleSaveBookingShipment}
                                          style={{
                                            borderRadius: 100,
                                            fontSize: 11
                                          }}
                                        >
                                          BOOK A LOAD
                                        </LoadingButton>
                                      </Grid>
                                    </Box>
                                  </>
                                )}
                              </>
                            )}
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })}
              </TableBody>

              {/* loader */}
              {loading && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}

              {/* empty list */}
              {searchLoadList.length == 0 && !loading && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        height="35vh"
                      >
                        <Iconify
                          icon={'bi:clipboard2-x-fill'}
                          sx={{ fontSize: 70, marginBottom: 2, color: '#010f58' }}
                        />
                        <Typography variant="h6" gutterBottom sx={{ color: '#010f58' }}>
                          You haven't saved any shipment yet
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && pagesCount > 1 && searchLoadList.length !== 0 && (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
                marginTop: 20,
                alignItems: 'center',
                marginBottom: 20
              }}
            >
              <Pagination
                color="primary"
                shape="rounded"
                page={page}
                size="small"
                count={pagesCount}
                onChange={handlePageChange}
                renderItem={(item) => <PaginationItem {...item} />}
              />
            </Box>
          )}
        </Container>

        {/* DETAILS dialog */}
        <Dialog open={openDetailsModal} onClose={handleCloseDetailsModal} fullWidth>
          <DialogTitle
            style={{
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingLeft: 20,
              paddingRight: 10,
              marginBottom: 0
            }}
          >
            Company Information
            <IconButton onClick={handleCloseDetailsModal}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers style={{ paddingLeft: 20, paddingTop: 0 }}>
            <Box sx={{ mt: 2 }}>
              <Box>
                <Grid
                  container
                  sx={{
                    marginTop: 3,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start'
                  }}
                >
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: 0.5
                    }}
                  >
                    <Typography
                      sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}
                    >
                      Name :
                    </Typography>
                    <Typography sx={{ flex: 1, fontSize: 16 }}>
                      {selectLoad?.company?.company
                        ? selectLoad?.company?.company
                        : selectLoad?.company?.first_name + ' ' + selectLoad?.company?.last_name}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: 0.5
                    }}
                  >
                    <Typography
                      sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}
                    >
                      Email :
                    </Typography>
                    <Typography sx={{ flex: 1, fontSize: 16 }}>
                      {selectLoad?.company?.email}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: 0.5
                    }}
                  >
                    <Typography
                      sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}
                    >
                      Score :
                    </Typography>
                    <Typography sx={{ flex: 1, fontSize: 16 }}>
                      {selectLoad?.company?.score}
                    </Typography>
                  </Box>
                </Grid>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        {/* BID MODAL */}
        <Dialog open={openBidModal} onClose={handleCloseBidModal} maxWidth="xs" fullWidth>
          <DialogTitle style={{ height: 50 }}>
            Place a Bid
            <IconButton onClick={handleCloseBidModal} sx={{ alignSelf: 'end', float: 'right' }}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            <TextField
              sx={{ marginTop: 1 }}
              fullWidth
              type="number"
              label="Rate"
              name="rate"
              value={rateFlat}
              onChange={(e) => {
                setRate(e.target.value);
              }}
              helperText={'*Required. Flat rate in USD.'}
              className="custom-textfield"
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>
              }}
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
            />
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: 10
              }}
            >
              <LoadingButton
                loading={isSaveLoading}
                variant="contained"
                sx={{ width: '50%', borderRadius: 100 }}
                onClick={HandlePlaceBid}
              >
                PLACE BID
              </LoadingButton>
            </Box>

            <Box style={{ backgroundColor: 'lightgrey', padding: '10px 10px', borderRadius: 5 }}>
              <Typography
                sx={{
                  fontSize: 11,
                  color: '#000000',
                  textAlign: 'start'
                }}
              >
                If your bid is accepted, you will receive a confirmation from the broker at email.
              </Typography>
            </Box>
          </DialogContent>
        </Dialog>

        {/* Map Dialog */}
        <Dialog open={mapOpen} onClose={() => setMapOpen(false)} maxWidth="md" fullWidth>
          <DialogContent>
            <LocationPickerMap
              open={mapOpen}
              onClose={() => setMapOpen(false)}
              locationType={locationType}
              selectedLocationFromForm={locationType === 'origin' ? origin : destination}
              onSelectLocation={handleSelectLocation}
            />
          </DialogContent>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Page>
    </LocalizationProvider>
  );
}

export default SaveShipmentList;
